import React from 'react';

import {hooks} from '../hooks';
import {components} from '../components';
import {theme} from '../constants';

export const DeleteAccount: React.FC = () => {
  const navigate = hooks.useAppNavigate();

  const renderContent = (): JSX.Element => {
    return (
      <div style={{padding: '50px 20px 20px 20px'}}>
        <img
          src={require('../assets/icons/10.png')}
          alt='سفارش موفقیت‌آمیز'
          style={{
            width: 225.18,
            display: 'block',
            margin: '0 auto',
            marginBottom: 14,
          }}
        />
        <h2
          style={{
            margin: 0,
            textAlign: 'center',
            ...theme.fonts.Mulish_700Bold,
            fontSize: 22,
            lineHeight: 1.2,
            color: theme.colors.mainColor,
            marginBottom: 14,
            textTransform: 'capitalize',
            whiteSpace: 'pre-line',
          }}
        >
          آیا مطمئن هستید؟
        </h2>
        <p
          style={{
            margin: '0 20px',
            textAlign: 'center',
            color: theme.colors.textColor,
            lineHeight: 1.7,
            marginBottom: 30,
            whiteSpace: 'pre-line',
          }}
        >
          این اقدام غیرقابل بازگشت است.{'\n'}تمامی داده‌های شما حذف خواهد شد.
        </p>
        <components.Button
          title='لغو'
          onClick={() => {
            navigate(-1);
          }}
          containerStyle={{marginBottom: 10}}
        />
        <components.Button
          title='مطمئنم'
          onClick={() => {
            navigate('/');
          }}
          colorScheme='light'
        />
      </div>
    );
  };

  return <>{renderContent()}</>;
};
